module.exports = __webpack_public_path__ + "static/Hero1-5eb5a042e1c08caa9613cf6d60d38fc1.png";